import {RoleName} from "../../../administration/users/Role";
import {User} from "../../../administration/users/User";
import {hasAccountServiceRole} from "../../../administration/users/AccountServiceRoles";

export type WithRestrictedEdit = {
  isEditable?: boolean
}

export function isEditableForRoles(user: User, editableForRoles: RoleName[]): boolean {
  let matchingRole = editableForRoles.find(role => {
    return hasAccountServiceRole(user, role);
  });
  return matchingRole !== undefined;
}
